module.exports = __webpack_public_path__ + "img/sv80.4cff09d3.svg";